export default "__VITE_ASSET__CkJvuhaa__"